import Axios from 'axios';

const API_URL = process.env.API_URL + '/api/v3/data/products/margin-types';

class MarginType {
  index() {
    return Axios.get(API_URL);
  }

  show(marginType) {
    return Axios.get(API_URL + `/${marginType}`);
  }
}

export default new MarginType();



// WEBPACK FOOTER //
// ./src/api/marginTypes.js